import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, LoadingController, ModalController, ModalOptions } from 'ionic-angular';

import {BusquedaPage} from '../../pages/busqueda/busqueda'

import { MovimientotesoreriaServiceProvider} from '../../providers/movimientotesoreria-service/movimientotesoreria-service';
import {AuthServiceProvider} from '../../providers/auth-service/auth-service';

/**
 * Generated class for the MovimientoTransferenciaTesoreriaPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-movimiento-transferencia-tesoreria',
  templateUrl: 'movimiento-transferencia-tesoreria.html',
})
export class MovimientoTransferenciaTesoreriaPage {

  objTransferencia:any={};
  cuentas=[];
  loading: any;
  detalleBusqueda: any;

  constructor(public navCtrl: NavController, public navParams: NavParams, public alertCtrl: AlertController,
  	public loadingCtrl:LoadingController, public auth:AuthServiceProvider, public modalCtrl: ModalController,
  	public tesoreriaServices:MovimientotesoreriaServiceProvider) {

  	this.botonNuevo();
  }

  ionViewDidLoad() {
  	this.tesoreriaServices.getCuentas().subscribe(val => {
  		this.cuentas = val;
  	});
  }

  botonNuevo(){
  	var tzoffset = (new Date()).getTimezoneOffset() * 60000;

  	this.objTransferencia.id=0;
  	this.objTransferencia.fecha= (new Date(Date.now() - tzoffset)).toISOString() ;;
  	this.objTransferencia.fechae= (new Date(Date.now() - tzoffset)).toISOString() ;;
  	this.objTransferencia.idempresa=1;
  	this.objTransferencia.referencia='';
  	this.objTransferencia.observacion='';
  	this.objTransferencia.idestado=0;
  	this.objTransferencia.valor=0;
  	this.objTransferencia.idtdoctes= 22;
  	this.objTransferencia.identidad= this.auth.usuario.identidad;
  	this.objTransferencia.idestadodocumento=0;
  	this.objTransferencia.detalle= [
  		{id:0, idcuenta:0, idtdoctes: 18, idestadodocumento:0, idestado:0},
  		{id:0, idcuenta:0, idtdoctes: 19, idestadodocumento:0, idestado:0}
  	];

  	
  }

  botonGrabar(){
  	this.objTransferencia.idcuenta = this.objTransferencia.detalle[0].idcuenta;

    if(this.objTransferencia.valor == 0){
        let alert = this.alertCtrl.create({
          title: 'Validacion de datos',
          subTitle: 'Ingrese los datos respectivos para almacenar el respectivo movimiento.',
          buttons: ['OK']
        });
        alert.present();
    }
    else{
    	
      	this.tesoreriaServices.guardar(this.objTransferencia).then((result) => {
    		this.showLoader('Se guardó correctamente!!',1000);
    		this.botonNuevo();
		}, (err) => {
      		console.log(err);
    	});

    }
  }

  botonBuscar(){
  	const myModalOptions: ModalOptions = {
      enableBackdropDismiss: false
    };
  	this.tesoreriaServices.buscar(this.objTransferencia.idtdoctes, 0, 0).subscribe((result) => {
  		this.detalleBusqueda={'parametro':result, 'campobus':'cuenta,valor,referencia,observacion'};
  		let myModal = this.modalCtrl.create(BusquedaPage,this.detalleBusqueda, myModalOptions);
  		myModal.onDidDismiss(data => {
  			if (data != null){
  				this.tesoreriaServices.buscar(this.objTransferencia.idtdoctes, 0, data.id).subscribe(resultado => {
  					this.objTransferencia = resultado;
  				});
  			} 
    		
  		});
    	myModal.present();
  	},
  	(err) => {
  		console.log(err);
  	});
  }

  botonEliminar(){
    if(this.objTransferencia.id == 0){
        let alert = this.alertCtrl.create({
          title: 'Validacion de datos',
          subTitle: 'Seleccione un movimiento para eliminar.',
          buttons: ['OK']
        });
        alert.present();
    }
    else{
        this.objTransferencia.idestado = 1;
        this.objTransferencia.detalle[0].idestado = 1;
        this.objTransferencia.detalle[1].idestado = 1;
      
        this.tesoreriaServices.guardar(this.objTransferencia).then((result) => {
        this.showLoader('Se eliminó correctamente!!',1000);
        this.botonNuevo();
    }, (err) => {
          console.log(err);
      });

    }
  }

  showLoader(mensaje,tiempo){
 
	this.loading = this.loadingCtrl.create({
	    content: mensaje,
	    duration: tiempo,
	    spinner: 'hide'
	});

	this.loading.present();

	this.loading.onDidDismiss(() => {
	  
	});
  }

  isValidNumber(event)
  {
    //console.log(this.objtesoreria.valor.toString().length -2 + " , " + this.objtesoreria.valor.toString().indexOf('.') )
    
      //return /\d|Backspace/.test(event.key);
      if (([8, 13, 27, 37, 38, 39, 40].indexOf(event.keyCode) > -1)) {
          // backspace, enter, escape, arrows
          return true;
      } else if ((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode == 190 && this.objTransferencia.valor.toString().indexOf('.') == -1 )) {
          // numbers 0 to 9 or .
          if(this.objTransferencia.valor.toString().indexOf('.') > -1 && this.objTransferencia.valor.toString().length - this.objTransferencia.valor.toString().indexOf('.') - 2  > 0)
            return false;

          return true;
      } else if (event.keyCode >= 96 && event.keyCode <= 105) {
          // numpad number
          return true;
      }
      return false;
  }
}



// WEBPACK FOOTER //
// ./src/pages/movimiento-transferencia-tesoreria/movimiento-transferencia-tesoreria.ts